"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentAka = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const shared_styles_1 = require("@/stylesheets/shared.styles");
let ComponentAka = class ComponentAka extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.items = [];
    }
    render() {
        if (!this.items.length)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <dl>
        <dt>a.k.a.</dt>
        ${this.renderItems()}
      </dl>
    `;
    }
    renderItems() {
        return this.items.map(item => this.renderItem(item));
    }
    renderItem(item) {
        return (0, lit_1.html) `
      <dd>${item}</dd>
    `;
    }
};
ComponentAka.styles = [
    shared_styles_1.resetStyles,
    (0, lit_1.css) `
      :host {
        display: none;
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], ComponentAka.prototype, "items", void 0);
ComponentAka = __decorate([
    (0, decorators_js_1.customElement)('mm-component-aka')
], ComponentAka);
exports.ComponentAka = ComponentAka;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tcG9uZW50LWFrYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImNvbXBvbmVudC1ha2EudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQW9EO0FBQ3BELHFEQUEyRDtBQUUzRCwrREFBeUQ7QUFHbEQsSUFBTSxZQUFZLEdBQWxCLE1BQU0sWUFBYSxTQUFRLGdCQUFVO0lBQXJDOztRQVMyQixVQUFLLEdBQWEsRUFBRSxDQUFBO0lBcUJ0RCxDQUFDO0lBbkJDLE1BQU07UUFDSixJQUFJLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxNQUFNO1lBQUUsT0FBTyxhQUFPLENBQUE7UUFDdEMsT0FBTyxJQUFBLFVBQUksRUFBQTs7O1VBR0wsSUFBSSxDQUFDLFdBQVcsRUFBRTs7S0FFdkIsQ0FBQTtJQUNILENBQUM7SUFFTyxXQUFXO1FBQ2pCLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsVUFBVSxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUE7SUFDdEQsQ0FBQztJQUVPLFVBQVUsQ0FBQyxJQUFZO1FBQzdCLE9BQU8sSUFBQSxVQUFJLEVBQUE7WUFDSCxJQUFJO0tBQ1gsQ0FBQTtJQUNILENBQUM7O0FBNUJNLG1CQUFNLEdBQUc7SUFDZCwyQkFBVztJQUNYLElBQUEsU0FBRyxFQUFBOzs7O0tBSUY7Q0FDRixDQUFBO0FBQytCO0lBQS9CLElBQUEsd0JBQVEsRUFBQyxFQUFFLFNBQVMsRUFBRSxLQUFLLEVBQUUsQ0FBQzsyQ0FBcUI7QUFUekMsWUFBWTtJQUR4QixJQUFBLDZCQUFhLEVBQUMsa0JBQWtCLENBQUM7R0FDckIsWUFBWSxDQThCeEI7QUE5Qlksb0NBQVkifQ==